import gsap from "gsap";
class BioLogosAnimation {
    constructor() {
        this.hero = document.querySelector(".bh-hero");
        this.setTitles = document.querySelectorAll(".bh-hero-title h1");
        this.logoSets = [];
        this.currentSet = 0;
        this.init();
    }

    init() {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop) {
            this.hero.classList.add('logo-placement-desktop');
        } else {
            this.hero.classList.add('logo-placement-mobile');
        }

        this.setTitles.forEach((title, index) => {
            gsap.set(title, { autoAlpha: 0 });

            const logosNodeList = document.querySelectorAll(`.logo-portco[data-set="${index}"]`);
            const logosArray = Array.from(logosNodeList);
            gsap.set(logosArray, { autoAlpha: 0 });

            const showLogos = isDesktop ? (parseInt(title.dataset.showLogos, 10) || 5) : 3;

            this.logoSets.push({ title, logos: logosArray, showLogos });
        });

        gsap.set('.portco-logos-wrap', { autoAlpha: 1 })
        gsap.set('.bh-hero-title', { autoAlpha: 1 })

        this.animateSet();
    }

    animateSet() {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const { title, logos, showLogos } = this.logoSets[this.currentSet];
        gsap.set(title, { autoAlpha: 0 });

        logos.forEach((logo, index) => {
            const randomX = Math.random() * 50 - 25;
            const randomY = Math.random() * 50 - 25;
            gsap.set(logo, { autoAlpha: 0, x: randomX, y: randomY });
        });

        gsap.to(title, { duration: 1, autoAlpha: 1,
            onComplete: () => {
                title.classList.add('shining');
                setTimeout(() => {
                    title.classList.remove('shining')
                }, 900);
            }
        });

        logos.slice(0, showLogos).forEach((logo, index) => {
            gsap.to(logo, { duration: 1, autoAlpha: 1, stagger: 0.15, delay: 0.4 });
        });

        if(isMobile) {
            setTimeout(() => {
                this.fadeOutSet();
            }, 2500);
        } else {
            setTimeout(() => this.animateNextLogo(showLogos), 1500);
        }
    }

    animateNextLogo(nextIndex) {
        const { logos, showLogos } = this.logoSets[this.currentSet];

        if (nextIndex < logos.length) {
            gsap.to(logos[nextIndex - showLogos], { duration: 1, autoAlpha: 0 });
            gsap.to(logos[nextIndex], { duration: 1, autoAlpha: 1, onComplete: () => {
                    setTimeout(() => this.animateNextLogo(nextIndex + 1), 100);
                } });
        } else {
            this.fadeOutSet();
        }
    }

    fadeOutSet() {
        const { title, logos } = this.logoSets[this.currentSet];
        title.classList.remove('shining');
        gsap.to(title, { duration: 1, autoAlpha: 0, delay: 1 });
        gsap.to(logos, { duration: 1, autoAlpha: 0, delay: 1, onComplete: () => this.nextSet() });
    }

    nextSet() {
        this.currentSet = (this.currentSet + 1) % this.logoSets.length;
        this.animateSet();
    }
}

export default BioLogosAnimation;
